export default __webpack_public_path__ + "static/media/tab-clicked.002ea3b2.svg";